"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _hooks = require("./hooks");
var BackIcon = function BackIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.707 6.293a1 1 0 0 1 0 1.414L7.414 11H19a1 1 0 1 1 0 2H7.414l3.293 3.293a1 1 0 0 1-1.414 1.414l-5-5a1 1 0 0 1 0-1.414l5-5a1 1 0 0 1 1.414 0z"
  }));
};
BackIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "icon": "BackToAssets__icon__1jFjM",
  "navigation-link": "BackToAssets__navigation-link__2mj4s",
  "navigationLink": "BackToAssets__navigation-link__2mj4s",
  "label": "BackToAssets__label__1JJGe",
  "back-to-list": "BackToAssets__back-to-list__13yS_",
  "backToList": "BackToAssets__back-to-list__13yS_",
  "spinner": "BackToAssets__spinner__OEfXu"
}; 
require('./BackToAssets.css');
var BackToAssets = function BackToAssets() {
  var trackEvent = (0, _exchangeReactHooks.useAnalyticsTracking)();
  var _usePreviousSectionIn = (0, _hooks.usePreviousSectionInfo)(),
    action = _usePreviousSectionIn.action,
    path = _usePreviousSectionIn.path;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: styles.backToList
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    role: "link",
    key: "back-to-asset-list",
    className: styles.navigationLink,
    to: path,
    onClick: function onClick() {
      return trackEvent("".concat(action, " clicked"));
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    "aria-hidden": true,
    size: "xs",
    className: styles.icon,
    "data-test-id": "back-to-icon"
  }, /*#__PURE__*/_react.default.createElement(BackIcon, null)), /*#__PURE__*/_react.default.createElement("span", {
    className: styles.label
  }, action)));
};
var _default = exports.default = BackToAssets;
//# sourceMappingURL=BackToAssets.js.map